export const ORDER_QUEUE_DEBOUNCE_INTERVAL_IN_MS = 3000;

/** Back off check-ids after a network failure (avoids spamming the API). */
export const REMOTE_ORDER_SYNC_BACKOFF_MS = 120000;

/** Wait before retrying outbox drain when a server order id is still missing. */
export const ORDER_ID_AWAIT_DEFER_MS = 60000;

export const ORDER_QUEUE_BATCH_CHUNK_SUZE = 10;

/** Delay (ms) before first check for server IDs after sending orders to the queue */
export const POST_SYNC_CHECK_DELAY_MS = 5000;
/** Extra delays (ms) for retries: first at 5s, then +10s, +20s, +60s so backend has time to persist */
export const POST_SYNC_CHECK_RETRY_DELAYS_MS = [10000, 20000, 60000];
